// extracted by mini-css-extract-plugin
module.exports = {"container":"Checkbox_container__1qro-","checkboxes":"Checkbox_checkboxes__KzN-e","label":"Checkbox_label__1uBuO"};